/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geomaptitle2Inputs */

const en_geomaptitle2 = /** @type {(inputs: Geomaptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity map`)
};

const de_geomaptitle2 = /** @type {(inputs: Geomaptitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitätskarte`)
};

/**
* | output |
* | --- |
* | "Activity map" |
*
* @param {Geomaptitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const geomaptitle2 = /** @type {((inputs?: Geomaptitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geomaptitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geomaptitle2(inputs)
	return de_geomaptitle2(inputs)
});
export { geomaptitle2 as "geoMapTitle" }